import {h, Fragment} from "preact"
import { SerpElement, useCurrencyFormatting } from "@nosto/preact"
import { productImagePlaceholder, productBadgeHandle } from "../helpers"
import { useState } from "preact/hooks"

export default function Product({ product }) {
    const { format } = useCurrencyFormatting()
    const tags = [
        product.onSale
            ? {
                  label: "Sale",
                  class: "ns-badge ns-badge-green-outline ns-d-inline-block ns-text-align-center"
              }
            : undefined
    ].filter(v => !!v)

    const [atcDisplayed, setAtcDisplayed] = useState(false);
    const [atcId, setAtcId] = useState('');
    const [pleaseSelectSizeShown, setPleaseSelectSizeShown] = useState(false);

    const showAtc = () => {
        setAtcDisplayed(true)
    }

    const hideAtc = () => {
        setAtcDisplayed(false)
    }

    const markdownPercentage = () => {
        if (product.listPrice && product.listPrice > product.price) {
            return Math.ceil((product.price - product.listPrice)/product.listPrice * 100)
        }
        return false;
    }

    const badge = productBadgeHandle(product);

    async function ajxUpdateHandler(sku) {
        if (atcId === ''){
            setPleaseSelectSizeShown(true)
        } else {

        let cartUrl = '/cart/add.js';
        // let numberOfItemsInCart = +document.querySelectorAll('.mini-cart.cart-mini .count')[0].textContent;


        const postBody = {
            items: [{
                id: sku,
                quantity: 1
            }]
            // ,

            // sections: document.querySelector('cart-drawer').getSectionsToRender().map(e => e.id)
        };

        const requestMetadata = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(postBody)
        };

        // let myInterval;

        // function myTimer(){
        //     if (document.querySelectorAll('.cart-drawer').length > 0){
        //         Nosto.reloadCart()
        //         clearInterval(myInterval);
        //     }
        // }

        fetch(cartUrl, requestMetadata)
            .then(res => res.json())
            // .then(() =>
            //     document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            //         bubbles: true,
            //     }))
            // ) 
            .then(()=>{document.getElementById('CartDrawer').open()})
            .then(res => document.querySelector('cart-drawer').renderContents(res))
            .then(()=>Nosto.reloadCart())  
            .then(setTimeout(() => {return document.querySelector('#CartDrawer').open()}, 500))
            // .then(()=>{myInterval = setInterval(myTimer, 1)})  
        }   
    }

    return (
        <SerpElement
            as="li"
            hit={product}
            class="ns-product collection-grid__grid-item col-span-1"
            onMouseLeave={hideAtc}            
            onClick={()=>{localStorage.setItem("scrollpoint", product.productId)}}
        >
            <product-card class="product-card group ns-product-card">
            <div class="product-card__image-container relative overflow-hidden ns-image-container" id={product.productId}>
                <a href={product.url} class="product-card__image">
                    <img class="ns-main-image w-full " src={`${product.imageUrl}&width=480 480w`}
                        srcset={`${product.imageUrl}&width=480 480w,
                                ${product.imageUrl}&width=768 768w,
                                ${product.imageUrl}&width=1024 1024w,
                                ${product.imageUrl}&width=1140 1140w,
                                ${product.imageUrl}&width=1280 1280w,
                                ${product.imageUrl}&width=1440 1440w,
                                ${product.imageUrl} 1920w,`} sizes="100vw" alt={product.name} style="--ar-mobile: 0.6665;  " />
                    <div class="ns-alt-image">
                        <img class="w-full " src={`${product.alternateImageUrls[0] ? product.alternateImageUrls[0] : product.imageUrl}&width=480 480w`} 
                        srcset={`${product.alternateImageUrls[0] ? product.alternateImageUrls[0] : product.imageUrl}&width=480 480w,
                        ${product.alternateImageUrls[0] ? product.alternateImageUrls[0] : product.imageUrl}&width=768 768w,
                        ${product.alternateImageUrls[0] ? product.alternateImageUrls[0] : product.imageUrl}&width=1024 1024w,
                        ${product.alternateImageUrls[0] ? product.alternateImageUrls[0] : product.imageUrl}&width=1140 1140w,
                        ${product.alternateImageUrls[0] ? product.alternateImageUrls[0] : product.imageUrl}&width=1280 1280w,
                        ${product.alternateImageUrls[0] ? product.alternateImageUrls[0] : product.imageUrl}&width=1440 1440w,
                        ${product.alternateImageUrls[0] ? product.alternateImageUrls[0] : product.imageUrl} 1920w`} sizes="100vw" alt={product.name} style="--ar-mobile: 0.6665;  " />
                    </div>
                    {/* <div class="product-card__badge absolute top-8 left-12">
                        <span class="badge__text">
                        {product.customFields?.find(field => field.key === 'seed-badge')?.value.toLowerCase() === 'coming soon'
                        ?
                        'Coming Soon'
                        :
                        product.availability !== "InStock"
                        ?
                        'Sold Out'
                        :
                        (product.listPrice && product.listPrice > product.price)
                        ?
                        'Sale'
                        :
                        product.customFields?.find(field => field.key === 'seed-badge')?.value 
                        ?
                        product.customFields?.find(field => field.key === 'seed-badge')?.value 
                        :
                        '' }
                        </span>
                    </div>       */}
                </a>
    

        {product.skus.filter(sku => sku.availability === "InStock").length > 0 &&
            <button class="ns-quick-add-button product-card__quick-add absolute py-6 px-12 bg-white-offWhite bottom-8 left-12 transition-all duration-400" onClick={showAtc}>Add +</button>
        }
        <div onMouseLeave={(e)=>e.stopPropagation()} class={`${atcDisplayed ? 'ns-active' : ''} ns-atc-container absolute bg-white w-full p-8`}>
            <button class="w-12 block m-8 mr-0 ml-auto" onClick={hideAtc}>
                <svg class="icon icon-close" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.49452 13.9999L14.4952 0.999947" stroke="currentColor"></path>
                    <path d="M1.49522 1L14.4952 14" stroke="currentColor"></path>
                </svg>
            </button>
            <div class="flex flex-wrap items-center justify-start gap-16">
            {product.skus.map((sku)=>{
               return <>
                    <input class="quick-add-input visually-hidden"  type="radio" id={`xs-s-midnight-navy--${sku.id}`} />
                    <label for={`xs-s-midnight-navy--${sku.id}`} onClick={()=>setAtcId(sku.id)} class={`${sku.availability === "InStock" ? "" : "ns-disabled"} ${atcId === sku.id ? 'ns-active' : ''} ns-atc-option hover:underline`}>                   
                        {sku.name.substring(0, sku.name.indexOf(' '))}                
                    </label>
                </>
            })}             
          </div>
          <span class={` ${pleaseSelectSizeShown ? '' : 'hidden'} text-red`}>Please select a size</span>
          <button class="button btn p-12 mt-16 w-full block" onClick={(event) => { event.preventDefault(); ajxUpdateHandler(atcId) }}>Add</button>
        </div>

        {/* <div class={`${atcDisplayed ? '-translate-y-full' : ''} absolute bg-white w-full transition-all p-8`} js-quick-add-form="">
            <button class="w-12 block m-8 mr-0 ml-auto hover:opacity-50 focus:opacity-50" js-quick-add-close="">
                <svg class="icon icon-close" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.49452 13.9999L14.4952 0.999947" stroke="currentColor"></path>
                <path d="M1.49522 1L14.4952 14" stroke="currentColor"></path>
                </svg>
            </button>
          <div class="flex flex-wrap items-center justify-start gap-16">
            
              
                
                <input class="quick-add-input visually-hidden" type="radio" id="xs-s-black--40233014460519" name="quick-add-variant-6834804195431" value="40233014460519" js-quick-add-input="" />
                <label for="xs-s-black--40233014460519" class="hover:underline">
                  
                  
                    XS/S
                  
                </label>
              
                
                <input class="quick-add-input visually-hidden" type="radio" id="m-l-black--40233014493287" name="quick-add-variant-6834804195431" value="40233014493287" js-quick-add-input="" />
                <label for="m-l-black--40233014493287" class="hover:underline">
                  
                  
                    M/L
                  
                </label>
              
            
          </div>
          <span class="hidden text-red" js-quick-add-error="">Please select a size</span>
          <button class="button btn p-12 mt-16 w-full block" js-quick-add-submit="">Add</button>
        </div> */}
      
    
  </div>
  <div class="product-card__info px-12 mt-8 ">
    {badge.text != null && <div style="margin-bottom:6px;"><span class="text-12 uppercase" style={{color: badge.textColor, backgroundColor: badge.bgColor, padding: "3px 6px"}}>{badge.text}</span></div>}
    <h3 class="product-card__title text-13 leading-normal mb-4">
      <a href={product.url} class="product-card__title-link">{product.name}</a>
    </h3>
    <div class="ns-prices-container product-card__price-container flex justify-start items-center leading-normal">
      
        <div class="product-card__price">${product.price}</div>
      {(product.listPrice && product.listPrice > product.price) && <span class="line-through">${product.listPrice}</span>}
      {/* {(product.customFields?.find(field => field.key === 'seed-next_to_price_text') && product.customFields?.find(field => field.key === 'seed-next_to_price_text_color')) && <span style={{color: product.customFields?.find(field => field.key === 'seed-next_to_price_text_color')?.value, marginLeft:'5px'}}>{product.customFields?.find(field => field.key === 'seed-next_to_price_text').value}</span>} */}
      {markdownPercentage() && <span style={{color:'#F50707', marginLeft:'5px'}}>{markdownPercentage()}%</span>}
    </div>
    
    
  </div>
            {/* <img
                class="ns-w-100 ns-h-auto"
                src={product.imageUrl ?? productImagePlaceholder}
                alt={product.name}
                width="600"
                height="400"
            />
            <div class="ns-relative ns-mt-2" data-nosto-element="product">
                {tags.length > 0 && (
                    <div class="ns-tags ns-absolute ns-mb-1">
                        {tags.map(v => (
                            <span class={v.class}>{v.label}</span>
                        ))}
                    </div>
                )}
                {product.brand && <div class="ns-color-black ns-mb-1 ns-font-4">{product.brand}</div>}
                <div class="ns-clipped ns-text-four-lines ns-text-md-three-lines ns-mb-2 ns-font-4">{product.name}</div>
                <div>
                    <span>{format(product.price)}</span>
                    {product.listPrice && product.listPrice > product.price && (
                        <span class="ns-color-black ns-font-4 ns-text-striked ns-ml-2">
                            {format(product.listPrice)}
                        </span>
                    )}
                </div>
            </div> */}
            </product-card>
        </SerpElement>
    )
}
